import { render, staticRenderFns } from "./MenuSelfService.vue?vue&type=template&id=b9febd1a&scoped=true"
import script from "./MenuSelfService.vue?vue&type=script&lang=js"
export * from "./MenuSelfService.vue?vue&type=script&lang=js"
import style0 from "./MenuSelfService.vue?vue&type=style&index=0&id=b9febd1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9febd1a",
  null
  
)

export default component.exports